import React, {useMemo} from "react";
import {Helmet} from "react-helmet";
import VotesManager from "./Manager/VotesManager";
import Proposals from "./Proposals/Proposals";
import Account from "../Account/Account";
import useResize from "../../hooks/useResize";
import './style.scss';

function Voting() {

    const { windowWidth } = useResize();

    const mobileView = useMemo(() => windowWidth <= 600, [windowWidth]);

    return (
        <div className="voting">
            <Helmet>
                <title>Voting - Roobee DAO</title>
            </Helmet>
            { !mobileView ?
                <div className="voting-header">
                    <h2>Voting</h2>
                    <Account />
                </div>
                    :
                <div className="voting-header">
                    <h2>Voting</h2>
                </div>
            }
            <div className="voting-content">
                <VotesManager />
            </div>
            <Proposals />
        </div>
    );
}

export default Voting;
